import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { getLayoutModel, workspaceSchema } from '../_pages/Work-space/constants'
import { updateIframeApp } from '../../_redux/actions/iframeActions'
import { Avatar } from 'dsm-react-lib'
import { getUserInitials } from '../../utility/Utils'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { EventType } from '../../utility/types'
import { appInsights } from '../../_services/AppInsights'
import { useWorkspaceService } from '../../_services/WorkspaceService'

const ProfileContainer = styled.div`
  display: flex;
  justify-content: start;
  margin-right: 1rem;

  img {
    margin-top: 1rem;
    margin-left: 1.2rem;
  }
`

const NameAndAppsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 16px 0px 0px 16px;
  margin-right: 1rem;
`
const NameText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 21px;
  line-height: 30px;
  color: var(--text-heading);
`

const AppsText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-decoration-line: underline;
  color: var(--color-info);

  a {
    color: var(--color-info);
  }
`

const MySpaceProfileCard = ({ user }) => {
  const { workspaceList } = useSelector((state) => state.workspaceReducer.workspaces)
  const iframeApps = useSelector((state) => state.iframeReducer.iframeApps)
  const trackWSAdd = useTrackEvent(appInsights, EventType.WorkspaceAdded)
  const dispatch = useDispatch()
  const { addWorkspaceToList } = useWorkspaceService()

  useEffect(() => {
    if (workspaceList?.length === 0 && iframeApps.length > 0) {
      const workspaceObj = { ...workspaceSchema, model: getLayoutModel(iframeApps) }
      addWorkspaceToList(workspaceObj)
      dispatch(updateIframeApp([]))
      trackWSAdd({
        properties: {
          workspaceId: workspaceObj.id,
          workspaceName: workspaceObj.name
        }
      })
    }
  }, [])

  return (
    <>
      <div className="text-center">
        <ProfileContainer>
          <Avatar
            content={user?.profilePictureBase64Encoded || getUserInitials(user?.displayName)}
            {...(user?.profilePictureBase64Encoded
              ? { size: '68px' }
              : { bgColor: 'light-secondary', size: 'x-large', className: 'ml-1 mr-0' })}
          />
          <NameAndAppsContainer>
            <NameText>Hi {user?.name?.split(',')[1] || user?.givenName}!</NameText>
            {workspaceList?.length > 0 && (
              <AppsText className="apps-open-tour">
                <Link
                  to={{
                    pathname: '/workspace'
                  }}
                  className="open-apps">
                  {workspaceList?.length}{' '}
                  {workspaceList?.length === 1 ? 'workspace ' : 'workspaces '}
                  open
                </Link>
              </AppsText>
            )}
          </NameAndAppsContainer>
        </ProfileContainer>
      </div>
    </>
  )
}
export default MySpaceProfileCard
